import { render, staticRenderFns } from "./CommissionsAndTaxesInfo.vue?vue&type=template&id=5b75c512&"
import script from "./CommissionsAndTaxesInfo.vue?vue&type=script&lang=js&"
export * from "./CommissionsAndTaxesInfo.vue?vue&type=script&lang=js&"
import style0 from "./CommissionsAndTaxesInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports